// extracted by mini-css-extract-plugin
export var amount = "styles-module--amount--fc5e3";
export var button = "styles-module--button--9d1d0";
export var container = "styles-module--container--3a49d";
export var content = "styles-module--content--2bab7";
export var description = "styles-module--description--d6d6e";
export var firstTitle = "styles-module--firstTitle--10634";
export var freebet = "styles-module--freebet--a4ef6";
export var image = "styles-module--image--68ba5";
export var imageMobile = "styles-module--imageMobile--c9839";
export var images = "styles-module--images--32a9c";
export var ru = "styles-module--ru--cfe32";
export var rulesLink = "styles-module--rulesLink--5ef0e";
export var secondTitle = "styles-module--secondTitle--de487";
export var text = "styles-module--text--b4207";
export var title = "styles-module--title--41509";